export default __webpack_public_path__ + "static/media/ACM logo textRight.040f83ee.svg";